import React from "react";
import { Link } from "react-router-dom";
import { SOLUTIONS } from "../data/content";
import Icon from "./Icon";
import "../styles/solutionCards.css";

const SLUG_ICON = {
  attendance: "attendance",
  "leave-permission": "leave",
  payroll: "payroll",
  "multi-branch": "branch",
  "admin-dashboard": "dashboard",
};

function SolutionCardGrid() {
  return (
    <div className="solution-cards">
      {SOLUTIONS.map((sol) => (
        <Link to={`/solutions/${sol.slug}`} className="solution-card" key={sol.slug}>
          <span className="solution-card-icon">
            <Icon name={SLUG_ICON[sol.slug] || "product"} size={22} />
          </span>
          <h3 className="solution-card-name">{sol.name}</h3>
          <p className="solution-card-tagline">{sol.tagline}</p>
          <span className="solution-card-link">
            Learn more <Icon name="arrow" size={14} />
          </span>
        </Link>
      ))}
    </div>
  );
}

export default SolutionCardGrid;
